import React, { useState } from "react";
import { Button, Form, FormGroup, Label, Input } from "reactstrap"; // Usar Reactstrap
import { useAuth } from "./AuthContext";
import { Link, useNavigate } from "react-router-dom"; // Para redirigir después de login
import Swal from "sweetalert2"; // Para notificaciones (aunque el AuthProvider ya las tiene, es bueno tener acceso)

// Usaremos validación manual simple por ahora, sin Availity para empezar
const LoginForm = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false); // Estado de carga del formulario
  const { login } = useAuth();
  const navigate = useNavigate();

  const { email, password } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Iniciar carga

    // Validación básica
    if (!email || !password) {
      Swal.fire("Error", "Por favor, introduce email y contraseña", "error");
      setLoading(false); // Finalizar carga
      return;
    }

    const result = await login(formData); // Llamar a la función login del contexto

    setLoading(false); // Finalizar carga

    if (result.success) {
      navigate("/"); // Redirigir a la página principal/dashboard al tener éxito
    }
    // El AuthProvider ya maneja las notificaciones de error
  };

  return (
    <Form onSubmit={onSubmit}>
      <FormGroup>
        <Label for="email">Email</Label>
        <Input
          type="email"
          name="email"
          id="email"
          placeholder="Introduce tu email"
          value={email}
          onChange={onChange}
          required // Validación HTML5 básica
        />
      </FormGroup>
      <FormGroup>
        <Label for="password">Contraseña</Label>
        <Input
          type="password"
          name="password"
          id="password"
          placeholder="Introduce tu contraseña"
          value={password}
          onChange={onChange}
          required // Validación HTML5 básica
        />
      </FormGroup>
      <Button color="primary" type="submit" block disabled={loading}>
        {loading ? "Iniciando sesión..." : "Iniciar Sesión"}
      </Button>

    </Form>
  );
};

export default LoginForm;
